import { useEffect, useState } from "react"
import arrayUtilities from "../../utilities/arrayUtilities"
import api from "../api/api";
var hash = require('object-hash');

export const SiteGroupSelection = ({ site, siteIds, toggleSiteId, toggleSiteGroup, organisationId, token, userSiteGroups, removeMultipleSiteGroups, isSiteChecked }) => {

    const [siteGroups, setSiteGroups] = useState(null);
    const [isRestrictSiteGroupsChecked, setIsRestrictSiteGroupsChecked] = useState(false);

    const selectedSiteGroups = arrayUtilities.isNullOrEmpty(siteGroups)
        ? []
        : siteGroups.reduce((acc, item) => {
            if (userSiteGroups.includes(item.id)) {
                acc.push(item.id)
            }
            return acc
        }, [])

    const fetchSiteGroups = (id) => {
        api.getSiteGroupsBySiteId(
            organisationId, id,
            data => setSiteGroups(data),
            error => console.log(error),
            token
        )
    }

    const handleSiteChange = (e) => {
        toggleSiteId(site.id)
        if (!e.target.checked) {
            setSiteGroups(null)
            removeMultipleSiteGroups(selectedSiteGroups)
        }
    }

    const handleSiteGroupChange = (id) => {
        if (siteGroups) {
            toggleSiteGroup(id)
        }
    }

    useEffect(() => {
        if (siteIds.includes(site.id)) {
            api.getSiteGroupsBySiteId(
                organisationId, site.id,
                data => {
                    setSiteGroups(data);
                    setIsRestrictSiteGroupsChecked(data.filter(item => userSiteGroups.includes(item.id)).length > 0)
                },
                error => console.log(error),
                token
            )
        } else {
            setSiteGroups(null)
        }
    }, [isSiteChecked])

    return (
        <div key={ hash({ site, siteIds }) } className="mb-2 pl-2">
            <div className="custom-control custom-checkbox">
                <input className="custom-control-input" type="checkbox" checked={ isSiteChecked } id={ `site-${ site.id }` } onChange={ handleSiteChange } />
                <label className="custom-control-label col-form-label col-form-label-sm" htmlFor={ `site-${ site.id }` }>{ site.name }</label>
            </div>
            {
                !arrayUtilities.isNullOrEmpty(siteGroups) &&
                <div className="ml-1 d-flex align-items-start">
                    <i className="fas fa-level-up-alt rotate-90 mr-2"></i>
                    <div className="border bg-white rounded-md p-2">
                        <div className="d-flex flex-column">
                            <p className="font-weight-semi-bold m-0 fs--1">Restrict access to specific site groups</p>
                            <div className='custom-control custom-switch align-items-center'>
                                <input className="custom-control-input" type="checkbox" id={ `${ site.id }-site-group-switch` } checked={ isRestrictSiteGroupsChecked } onChange={ e => {
                                    setIsRestrictSiteGroupsChecked(!isRestrictSiteGroupsChecked);
                                    if (e.target.checked) {
                                        fetchSiteGroups(site.id)
                                    } else {
                                        removeMultipleSiteGroups(selectedSiteGroups)
                                    }
                                } } />
                                <label className="custom-control-label custom-toggle" htmlFor={ `${ site.id }-site-group-switch` }></label><p className="m-0 mt-1 fs--1">{ isRestrictSiteGroupsChecked ? <>Yes - User can only access the following site groups</> : <>No - User can access all site groups</> }</p>
                            </div>
                        </div>
                        {
                            isRestrictSiteGroupsChecked &&
                            siteGroups.map(item =>
                                <div className="custom-control custom-checkbox ml-4" key={ item.id }>
                                    <input onChange={ (e) => handleSiteGroupChange(item.id) } className="custom-control-input" id={ item.id } type="checkbox" checked={ selectedSiteGroups.includes(item.id) } value={ item.id } />
                                    <label className="custom-control-label col-form-label col-form-label-sm fs--1" htmlFor={ item.id }>{ item.name }</label>
                                </div>
                            )
                        }
                    </div>
                </div>
            }
        </div>
    )
}